/**
 * @module Inline CTA
 * @description JS for Inline CTA Shortcode
 */
import tagularModule from 'js/store/helpers/tagular.js';

const els = {
  ctas: null
};

/**
 * @function generateIdNumber
 * @description
 */
const generateIdNumber = () => {
  // Generate 20 digit random integer
  return Math.round(Math.random() * 10000000).toString() + new Date().getTime();
}

/**
 * @function addParams
 * @description Add our url params
 */
const addParams = ( cta ) => {
  const url = new URL( cta.getAttribute( 'href' ) );
  const params = url.searchParams;

  params.set( 'cid', window._Cohesion.sessionId );
  params.set( 'source_cid', generateIdNumber() );

  // Sub ID
  if( url.hostname === 'auto.everquote.com' ) {
    params.set( 'subid', '11' );
  }

  url.search = params.toString();
  cta.setAttribute( 'href', url.toString() );
};

/**
 * @function updateText
 * @description Update our button text
 */
const updateText = ( target ) => {
  target.innerText = 'Return to Form';
};

/**
 * @function trackClick
 * @description Fire our tagular event
 */
const trackClick = ( event ) => {
  const { target } = event;

  const webElement = {
    location: 'InlineCTA',
    position: '1',
    elementType: 'CTA',
    text: target.innerText
  }
  tagularModule.elementClicked(
    webElement
  )

  updateText( target );
};

/**
 * @function bindEvents
 * @description Bind events for this module
 */
const bindEvents = ( cta ) => {
  cta.addEventListener('click',  trackClick)
  cta.addEventListener('click', () => { 
    setTimeout(() => { window.location.href = `${window.location.origin}/insurance/rates/`}, 100);
 })
};

/**
 * @function init
 * @description Kick off this modules functions
 */
const init = () => {
  els.ctas = document.querySelectorAll( '.insurance-inline-cta__button' );

  if( ! els.ctas ) {
    return;
  }

  els.ctas.forEach( ( cta ) => {
    addParams( cta );
    bindEvents( cta );
  } );
};

const cohesion = window.cohesion || false;
if ( cohesion ) {
  cohesion( 'ready', init );
} else {
  init();
}
